import React from 'react';
import { Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getEnvironmentHue, tagStyle } from '../theme/statusTokens';

export interface EnvBadgeProps {
  env?: string;
  /** Show a TTL hourglass marker for dynamic environments. */
  dynamic?: boolean;
}

/** Environment tag (dev / stage / prod / dynamic envs). */
const EnvBadge: React.FC<EnvBadgeProps> = ({ env, dynamic }) => {
  const theme = useTheme();
  if (!env) return null;
  const style = tagStyle(getEnvironmentHue(env), theme.palette.mode);
  return (
    <Chip
      label={dynamic ? `${env} ⏳` : env}
      size="small"
      sx={{
        backgroundColor: style.bg,
        color: style.text,
        border: `1px solid ${style.border}`,
        fontWeight: 600,
        fontSize: '0.7rem',
        height: 20,
        '& .MuiChip-label': { px: 0.9 },
      }}
    />
  );
};

export default EnvBadge;
